// extracted by mini-css-extract-plugin
export default {"description":"ProductDescription_description__dtZQi","title":"ProductDescription_title__zKM5s","table_item":"ProductDescription_table_item__4D5nf"};